import { useEffect } from 'react';
import { GPURenderer } from '@/render/GPURenderer';

export const useWebGL = (
  webglCanvasRef: React.RefObject<HTMLCanvasElement | null>,
  webglRendererRef: React.MutableRefObject<GPURenderer | null>
) => {
  useEffect(() => {
    if (webglCanvasRef.current && !webglRendererRef.current) {
      try {
        webglRendererRef.current = new GPURenderer(webglCanvasRef.current);
      } catch (e) {
        console.error("GPU/WebGL Initialization Failed", e);
      }
    }

    return () => {
      if (webglRendererRef.current) {
        try {
          webglRendererRef.current.dispose();
        } catch (e) {
          console.warn("Disposing GPURenderer failed:", e);
        }
        webglRendererRef.current = null;
      }
    };
  }, [webglCanvasRef, webglRendererRef]);
};
